import { useNavigate } from "react-router";
import { Report } from "../../generated/fresh-guard-api";

export const useReportingController = () => {
  const navigate = useNavigate();

  const handleReportMarketComponentHistoryClick = () => {
    navigate(`/report?type=${Report.MarketComponentHistory}`);
  };

  const handleReportMarketComponent_30_60_90_VerificationClick = () => {
    navigate(`/report?type=${Report.MarketComponent306090Verification}`);
  };

  const handleReportMarketComponentWithoutCriticalBBDClick = () => {
    navigate(`/report?type=${Report.MarketComponentWithoutCriticalBbd}`);
  };

  const handleReportMarketComponentWhereShortDescriptionNotEqualsNumberClick =
    () => {
      navigate(
        `/report?type=${Report.MarketComponentWhereShortDescriptionNotEqualsNumber}`,
      );
    };

  const handleReportUserClick = () => {
    navigate(`/report?type=${Report.User}`);
  };

  return {
    handleReportMarketComponentHistoryClick,
    handleReportMarketComponent_30_60_90_VerificationClick,
    handleReportMarketComponentWithoutCriticalBBDClick,
    handleReportMarketComponentWhereShortDescriptionNotEqualsNumberClick,
    handleReportUserClick,
  };
};
